export const getProductImageUrl = (product, response) => {
  const imageId = product.relationships?.images?.data?.[0]?.id.uuid;
  if (!imageId) return null;

  const includedArray = response?.data?.included || response?.included || [];

  const imageEntity = includedArray.find(
    item => item.id.uuid === imageId && (item.type === 'image' || item.type === 'listingImage')
  );

  const variants = imageEntity?.attributes?.variants;
  return variants?.['square-small']?.url || variants?.['landscape-crop']?.url || null;
};